/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { ID, WithVersion } from '@gh/common-shared-data';
import { createEnum, EnumSet, WithOptimisticLock } from '@gh/core-data';

export const UoMDimension = createEnum('UOM_DIMENSION', {
  Area: 'AREA',
  Length: 'LENGTH',
  Height: 'HEIGHT',
  Width: 'WIDTH',
  Depth: 'DEPTH',
});

export type UoMDimension = EnumSet<typeof UoMDimension>;

export type UomListItemDto = WithVersion<WithOptimisticLock<{
  id: ID;
  code: string;
  name: string;
  description: string;
  usePieces: boolean;
  format: string;
  dimension1: UoMDimension;
  dimension1User: string;
  dimension2: UoMDimension;
  dimension2User: string;
  dimension3: UoMDimension;
  dimension3User: string;
  roundUp: number;
  canBeDeleted: boolean;
}>>;
